import { ApiText } from '../api-text';
import { ReportTypeCode } from '@enums/report-type-code.enum';

export class ReportType {
    text: ApiText;
    code: ReportTypeCode;
}
